// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2OGUh","productName":"Table_productName__ykF9o"};